import LoginModal from 'libs/login-modal';

import GalleryServices from '../services';

import RunnableVM from './runnable-vm';
import WaveSurferVM from './wave-surfer-vm';
import VideoVM from './video-vm';
import PreviewableVM from './previewable-vm';
import TextVM from './text-vm';
import CodeVM from './code-vm';
import LinkVM from './link-vm';
import DicomVM from './dicom-vm';

import './ko-gallery-slick';

export default function(data) {
  this.mobileBreakPoint = 768;
  this.$window = $(window);
  this.loadingContainerId = ko.observable();
  this.windowWidth = ko.observable(this.$window.width());
  this.windowHeight = ko.observable(this.$window.height());

  this.mobileView = ko.computed(() => this.windowWidth() < this.mobileBreakPoint)

  this.currentBrowsingScope = ko.observable(); //Global or course?
  this.currentBrowsingScale = ko.observable(); //All or specific course/work?
  this.currentUserType = ko.observable();

  this.publicView = ko.computed(() => this.currentUserType() == 'public')

  this.memberView = ko.computed(() => this.currentUserType() == 'member')

  this.enrolledView = ko.computed(() => this.currentUserType() == 'enrolled');

  this.courseworkEntryId = ko.observable();
  this.courseworkEntry = ko.observable();
  this.courseworkEntries = ko.observableArray();
  this.courseworkEntriesSort = ko.observable('created_at');
  this.totalCourseworkEntries = ko.observable();
  this.carouselPageList = {};
  this.tooltips = [];

  this.referrer = ko.observable();
  this.fullView = ko.observable(false);
  this.fullViewOverride = ko.observable(false); //Did the user manually enter full view?
  this.showUsers = ko.observable(false);
  this.hideNavElements = ko.observable(false);
  this.mouseOverCarousel = ko.observableArray(false);
  this.projectRunnable = ko.observable(false);
  this.descriptionVisible = ko.observable(false);
  this.newComment = ko.observable();
  this.activeComment = ko.observable();
  this.comments = ko.observableArray([]);
  this.showCommentField = ko.observable(false);
  this.replyingTo = ko.observable();
  this.currentSlideNumber = ko.observable(1);
  this.initialSlideIndex = ko.observable(0);
  this.numSlides = ko.observable(0);
  this.viewMode = ko.observable('preview');

  this.viewMode.subscribe(mode => this.refreshURL({view: mode}));

  this.currentFieldEntry = ko.observable({});

  this.currentFieldEntryId = ko.computed(() => {
    return this.currentFieldEntry() &&
      this.currentFieldEntry().id || (
        this.courseworkEntry() &&
          this.courseworkEntry().coursework_field_entries().length &&
            this.courseworkEntry().coursework_field_entries()[0].id()
      );
  });

  this.currentFieldEntryObj = ko.computed(() => {
    if (this.courseworkEntry()) {
      return this.courseworkEntry().coursework_field_entries().find(
        entry => entry.id() == this.currentFieldEntryId()
      );
    } else {
      return null;
    }
  });

  this.currentFieldEntryDownloadPath = ko.computed(() => {
    if (this.currentFieldEntryId())
      return Kadenze.Routes.coursework_field_entry_download_path(this.currentFieldEntryId());
  });

  this.courseList = ko.observableArray();
  this.courseworkList = ko.observableArray();
  this.selectedCourseId = ko.observable();
  this.selectedCourseworkId = ko.observable();

  this.fileTypes = ko.computed(() => {
    if (this.courseworkEntry() && this.courseworkEntry().coursework_field_entries) {
      return [...new Set(this.courseworkEntry().coursework_field_entries().map(
        entry => s.humanize(entry.type())
      ))]
    } else {
      return {}
    }
  });

  this.selectedFileType = ko.observable();

  this.selectedFileType.subscribe(value => {
    const type = s.underscored(value);
    const slick = this.slider[0].slick;

    slick.unfilterSlides();

    if (!_.isEmpty(type))
      slick.filterSlides(`[type=${type}]`);

    this.currentSlideNumber(slick.currentSlide + 1);
    this.numSlides(slick.slideCount);

    slick.goTo(0);

    //TODO: This does not fire afterChange event, need to find a patch for slickslider:
    //https://github.com/kenwheeler/slick/issues/1245
  });

  this.commentPaginator = ko.observable();
  this.commentSort = ko.observable('newest'); //or oldest or likes

  this.toggleDesc = () => {
    if (this.mobileView()) {
      this.toggleMobileDesc();
    } else {
      this.descriptionVisible(!this.descriptionVisible());
    }
  };

  this.headerVisible = ko.computed(() => !(this.fullView() || this.viewMode() != 'preview'));

  this.loginOrRegister = () => {
    const deferred = $.Deferred();

    if (this.publicView()) {
      const $el = $('#js-course-enroll-modal--authenticate');

      const args = {
        onLogin: response => {
          this.currentUserType(
            response.course_ids.includes(this.courseworkEntry().course.id()) ?
              'enrolled' :
              'member'
          );

          deferred.resolve();

          $el.modal('hide');
        },

        onRegister: response => {
          Kadenze.Analytics.track(
            'student_ui',
            'enrollment_started',
            { source_medium: 'gallery_viewer' }
          );

          this.currentUserType('member');

          deferred.resolve();

          $el.modal('hide');
        },

        trackingData: Object.assign({}, this.trackingData(), { source: 'gallery comment' })
      };

      const vm = new LoginModal(args);

      ko.cleanNode($el[0]);

      ko.applyBindingsWithValidation(
        vm,
        $el[0],
        Object.assign({}, Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS, { insertMessages: false })
      );

      $el.on('shown.bs.modal', () => vm.initSSOEvents());

      $el.modal('show');
    } else {
      deferred.resolve();
    }

    return deferred;
  };

  this.trackingData = () => {
    const data = ko.mapping.toJS(this.courseworkEntry().tracking_data);

    return Object.assign({}, data, {
      coursework_name: this.courseworkEntry().coursework.name(),
      course_name: this.courseworkEntry().course.name()
    });
  };

  this.interceptURLParams = () => {
    let searchParams = Kadenze.Util.getURLParams(location.search);

    //Show a specific view
    if (!_.isEmpty(searchParams['view'])) {
      if (searchParams['view'] == 'comment') {
        //If this is about to jump to a different slide, hold off on fetching comments
        const jumpToSlide = !_.isEmpty(searchParams['slide']) && !isNaN(parseInt(searchParams['slide']));
        this.showComment(!jumpToSlide);
      } else if (searchParams['view'] == 'code') {
        this.showCode();
      }
    }

    //Jump to a specific slide
    if (this.courseworkEntry() && !isNaN(parseInt(searchParams['slide']))) {
      this.setInitialSlideIndex(searchParams['slide']);
    } else if (this.courseworkEntry() && !isNaN(parseInt(this.courseworkEntry().initial_slide_id()))) {
      this.setInitialSlideIndex(this.courseworkEntry().initial_slide_id());
    }

    //Set browsing mode
    if (_.isUndefined(this.selectedCourseworkId())) {
      if (!_.isEmpty(searchParams['browse']) && searchParams['browse'] == 'all') {
        this.selectedCourseworkId(-1);
      } else {
        this.selectedCourseworkId(this.courseworkEntry().coursework.id());
      }
    }

    if (_.isUndefined(this.selectedCourseId())) {
      if (!_.isEmpty(searchParams['browse']) && searchParams['browse'] == 'all') {
        this.selectedCourseId(-1);
      } else {
        this.selectedCourseId(this.courseworkEntry().course.id());
      }
    }

    //Set browsing scope
    if (!_.isEmpty(searchParams['browsing_scope'])) {
      this.currentBrowsingScope(searchParams['browsing_scope']);
    }

    //Set browsing scale
    if (!_.isEmpty(searchParams['browse'])) {
      this.currentBrowsingScale(searchParams['browse']);
    }
  };

  this.bindKeyboardNavEvents = () => {
    $(document).off('keydown').on('keydown', e => {
      //
      // TODO: Quill?

      const url_string = e.currentTarget.URL
      const url = new URL(url_string);
      const galleryViewMode = url.searchParams.get("view");

      //
      if (e.target.className == 'redactor-editor')
        return;

      if (galleryViewMode !== 'comment'){
        if(e.keyCode == 37) {
          if (this.currentSlideNumber() == 1) {
            this.showCourseworkEntry(this.courseworkEntry().prev_coursework_entry_id());
          } else {
            this.slider.slick('slickPrev');
          }
        } else if (e.keyCode == 39) {
          if (this.numSlides() == this.currentSlideNumber()) {
            this.showCourseworkEntry(this.courseworkEntry().next_coursework_entry_id());
          } else {
            this.slider.slick('slickNext');
          }
        }
      }
    });
  };

  this.showWelcomeModal = () => {
    if ((Kadenze.isKadenze) && this.publicView() && _.isEmpty($.cookie('GWMShown'))) {
      $('#gallery_welcome_modal').modal('show');
      $.cookie('GWMShown', true, { expires: 365, path: '/' });
    }
  };

  this.initUI = () => {
    this.slider = $('#js-courseworkSlideHolder');

    this.$window.resize(() => {
      this.windowWidth(this.$window.width());
      this.windowHeight(this.$window.height());
      this.resizeSlideMedia();
    });

    this.bindKeyboardNavEvents();

    if (this.mobileView()) {
      this.showComment();
    }

    if (typeof data.onLoad === 'function')
      data.onLoad(this);

    this.showWelcomeModal();
  };

  this.reInitUI = () => {
    this.setInitialSlideIndex(this.courseworkEntry() && this.courseworkEntry().initial_slide_id());
    this.selectedFileType(undefined);
  };

  this.initSlide = slideEl => {
    if (_.isEmpty(slideEl) || slideEl.initialized)
      return;

    const vmValue = slideEl.getAttribute('vm')

    let slideFn;

    if (vmValue) {
      const slideName = vmValue.replace(/VM$/, '');
      slideFn = this[`init${slideName}Slide`]
    } else {
      slideFn = this.initGenericSlide
    }

    slideFn(slideEl);
  };

  this.slideVMParams = el => {
    return {
      id: el.getAttribute('id'),
      courseId: this.courseworkEntry().course.id(),
      courseworkId: this.courseworkEntry().coursework.id(),
      type: s.capitalize(el.getAttribute('type')),
      src: el.getAttribute('src'),
      h264_360_url: el.getAttribute('h264_360_url'),
      h264_720_url: el.getAttribute('h264_720_url'),
      node: el,
      parent: this
    };
  };

  this.initRunnableSlide = el => {
    el.vm = new RunnableVM(this.slideVMParams(el));
    el.initialized = true;
  };

  this.initPreviewableSlide = el => {
    el.vm = new PreviewableVM(this.slideVMParams(el));
    el.initialized = true;
  };

  this.initWaveSurferSlide = el => {
    const player = el.querySelector('.js-ws-audio-player');
    const vm = new WaveSurferVM(this.slideVMParams(el));

    ko.cleanNode(player);
    ko.applyBindings(vm, player);

    el.vm = vm;
    el.initialized = true;
  };

  this.initVideoSlide = el => {
    el.vm = new VideoVM(this.slideVMParams(el));
    el.initialized = true;
  };

  this.initTextSlide = el => {
    el.vm = new TextVM(this.slideVMParams(el));
    el.initialized = true;
  };

  this.initCodeSlide = el => {
    el.vm = new CodeVM(this.slideVMParams(el));
    el.initialized = true;
  };

  this.initLinkSlide = el => {
    el.vm = new LinkVM(this.slideVMParams(el));
    el.initialized = true;
  };

  this.initDicomSlide = el => {
    el.vm = new DicomVM(this.slideVMParams(el));
    el.initialized = true;
  };

  this.initGenericSlide = el => {
    el.vm = this.slideVMParams(el);
    el.initialized = true;
  };

  this.resizeSlideMedia = _.debounce(() => {
    const $mediaArea = $('.js-coursework-view__media-area');
    const $media = $('.js-coursework-view__img, .vjs-tech, .js-previewable, .js-previewable-loading');

    $media.css('max-height', $mediaArea.height());

    const $slickList = $('.slick-list');
    const $currentSlide = $('.slick-current');

    $slickList.css('height', $currentSlide.height());
  }, 50);

  this.toggleFullView = (item, event) => {
    this.fullView(!this.fullView());

    if (this.fullView())
      this.showUsers(false);

    this.fullViewOverride(item && event && this.fullView());

    if (!this.enrolledView()) {
      if (this.fullView()) {
        $('#main-nav').hide();
      } else if (this.viewMode() === 'preview') {
        $('#main-nav').show();
      }
    }

    if (this.fullView() && this.fullViewOverride())
      this.initHideNavElementTimeout();

    setTimeout(() => $(window).trigger('resize'), 100);
  };

  this.initFullViewTimeout = () => {
    const durationInMs = 5000;

    const setTimer = () => {
      clearTimeout(this.fvTimeout);

      this.fvTimeout = setTimeout(() => {
        if (!this.fullView())
          this.toggleFullView();
      }, durationInMs);
    };

    const resetTimer = () => {
      if (this.fullView() && !this.fullViewOverride())
        this.toggleFullView();

      setTimer();
    };

    $(document).off('mousemove.fullViewTimeout')
      .on('mousemove.fullViewTimeout', resetTimer);

    $(document).off('click.fullViewTimeout')
      .on('click.fullViewTimeout', resetTimer);

    setTimer();
  };

  this.clearFullViewTimeout = () => {
    $(document).off('mousemove.fullViewTimeout');
    $(document).off('click.fullViewTimeout');

    clearTimeout(this.fvTimeout);

    $('#main-nav').show();
  };

  this.initHideNavElementTimeout = () => {
    let timeout;
    const durationInMs = 5000;

    const setTimer = () => {
      clearTimeout(timeout);

      timeout = setTimeout(() => {
        if (this.fullView() && this.fullViewOverride())
          this.hideNavElements(true);
      }, durationInMs);
    };

    const resetTimer = () => {
      this.hideNavElements(false);
      setTimer();
    };

    $(document)
      .off('mousemove.initHideNavElementTimeout')
      .on('mousemove.initHideNavElementTimeout', resetTimer);

    $(document)
      .off('click.initHideNavElementTimeout')
      .on('click.initHideNavElementTimeout', resetTimer);

    setTimer();
  };

  this.currentSlideEl = () => {
    const slick = this.slider.get(0).slick;
    return slick.$slides[slick.currentSlide];
  };

  this.getState = ko.computed(() => {
    const layoutState = this.viewMode() ?
      `state-${this.viewMode()}` :
      'state-preview';

    const userState = this.currentUserType() ?
      `is-${this.currentUserType()}` :
      'is-enrolled';

    return `${layoutState} ${userState}`;
  });

  this.toggleCode = () => {
    if( this.viewMode() == 'preview' ) {
      this.viewMode('code');
    } else {
      this.viewMode('preview');
    }
  };

  this.isPreviewMode = ko.computed(() => this.viewMode() == 'preview');

  this.isCommentMode = ko.computed(() => this.viewMode() == 'comment');

  this.isCodeMode = ko.computed(() => this.viewMode() == 'code');

  this.isRunnableCodeVisible = ko.computed(() => {
    let hasNotebooksInZip = true;
    let runnableFilesLoaded = false;

    if (this.currentFieldEntry().runnableView) {
      runnableFilesLoaded = this.currentFieldEntry().runnableView.runnableFiles().length > 0;

      hasNotebooksInZip = this.currentFieldEntry().runnableView.runnableFiles().filter(
        file => s.endsWith(file.name, 'ipynb')
      ).length !== 0;
    }

    return this.currentFieldEntry() &&
      this.currentFieldEntry().type == 'Runnable' &&
        this.currentFieldEntryObj() &&
          this.currentFieldEntryObj().extension() != '.ipynb' &&
            runnableFilesLoaded &&
              !hasNotebooksInZip
  });

  this.prevSlide = () => {
    this.slider.slick('slickPrev');
  };

  this.nextSlide = () => {
    this.slider.slick('slickNext');
  };

  this.pauseCurrentSlide = () => {
    if (this.currentFieldEntry() && typeof this.currentFieldEntry().pause === 'function') {
      try {
        this.currentFieldEntry().pause();
      } catch (e) {
        console.log(e);
      }
    }
  };

  this.showPreview = () => {
    if (this.viewMode() !== 'preview') {
      const prevViewMode = this.viewMode();

      this.viewMode('preview');

      if (prevViewMode !== 'code')
        this.refreshSlick();

      if (this.publicView())
        $('#main-nav').show();
    }
  };

  this.showComment = (fetchComments = true) => {
    if (this.viewMode() === 'comment') {
      this.showPreview();
    } else {
      if (this.publicView())
        $('#main-nav').hide();

      if (fetchComments)
        this.fetchComments();

      this.viewMode('comment');
      this.refreshSlick();
    }
    this.clearFullViewTimeout();
  };

  this.showCode = () => {
    if (this.viewMode() === 'code') {
      this.showPreview();
    } else {
      if (this.publicView())
        $('#main-nav').hide();

      this.viewMode('code');

      setTimeout(() => { Prism.highlightAll(); }, 1800);
    }
  };

  this.refreshSlick = () => {
    const slick = (this.slider && this.slider[0] && this.slider[0]['slick']);

    if (slick) {
      TweenLite.to(this, .5, {
        onUpdate: () => {
          slick.refresh();
          $(window).trigger('resize');
        }
      });

      this.numSlides(slick.slideCount);

      this.currentSlideNumber(slick.currentSlide + 1);
    }
  };

  this.toggleMobileOptions = () => {
    $('#coursework_entry_filter_modal').modal('toggle');
  };

  this.toggleMobileDesc = () => {
    $('#coursework_entry_description_modal').modal('toggle');
  };

  this.courseworkEntryNotes = () => {
    if (_.isEmpty(this.courseworkEntry().description())) {
      return this.courseworkEntry().coursework.description();
    } else {
      return this.courseworkEntry().description();
    }
  };

  this.courseworkEntryFiles = ko.computed(() => {
    if (this.courseworkEntry()) {
      const exts = this.courseworkEntry().coursework_field_entries().map(
        entry => _.isEmpty(entry.extension()) ?
          null :
          entry.extension().substring(1)
      );

      return _.map(_.pairs(_.countBy(_.compact(exts), ext => ext)), pair => `${pair[1]} ${pair[0].pluralize(pair[1])}`);
    } else {
      return [];
    }
  });

  this.setInitialSlideIndex = id => {
    let slideIndex = 0;

    if (!isNaN(parseInt(id))) {
      const fieldEntryId = parseInt(id);

      slideIndex = this.courseworkEntry().coursework_field_entries().findIndex(
        entry => entry.id() == fieldEntryId
      );
    }

    this.initialSlideIndex(slideIndex >= 0 ? slideIndex : 0);
  };

  this.toggleEntriesCarousel = () => this.showUsers(!this.showUsers());

  this.closeEntriesCarousel = _.throttle(() => {
    const show = this.showUsers();

    if (show && !this.mouseOverCarousel())
      this.showUsers(!show);
  }, 500, { leading: false });

  this.bindCourseworkEntry = data => {
    this.pauseCurrentSlide();

    this.courseworkEntry(ko.mapping.fromJS(data));

    if (this.showUsers())
      this.goToCarouselEntry(this.courseworkEntry().id());
  };

  this.showCourseworkEntry = id => {
    if (!isNaN(parseInt(id)))
      this.courseworkEntryId(id);
  };

  this.fetchCourseworkEntry = mode => {
    let request = null;

    if (mode === 'find') {
      if (this.currentBrowsingScope() === 'global') {
        request = this.findCourseworkEntryByCourse(this.selectedCourseId());
      } else {
        request = this.findCourseworkEntryByCoursework(this.selectedCourseworkId());
      }
    } else {
      request = this.getCourseworkEntry(this.courseworkEntryId());
    }

    if (request) {
      request.done(response => {
        this.bindCourseworkEntry(response);

        //Pre-fetch surrounding entries
        if (!isNaN(parseInt(response.next_coursework_entry_id))) {
          this.getCourseworkEntry(response.next_coursework_entry_id);
        }
        if (!isNaN(parseInt(response.prev_coursework_entry_id))) {
          this.getCourseworkEntry(response.prev_coursework_entry_id);
        }

        this.reInitUI();
      });
    }
  };

  this.fetchCourseworkEntries = () => {
    const mp = new Mprogress({
      template: 4,
      start: true,
      parent: '#js-coursework-entries-loader'
    });

    return this.listCourseworkEntries(
      this.selectedCourseId(),
      this.selectedCourseworkId(),
      { coursework_entry_id: this.courseworkEntry().id() }
    ).done(response => {
      this.totalCourseworkEntries(response.meta.total_count);

      this.courseworkEntries(ko.mapping.fromJS(response.coursework_entries)());

      mp.end();
    });
  };

  this.loadAdjescentCarouselEntries = item => {
    if (_.isEmpty(item))
      return;

    const curPage = item.in_page();

    this.carouselPageList[curPage] = true;

    let response = null;

    if (item.first_in_page() && curPage > 1) {
      //Load previous page
      const prevPage = (curPage - 1);

      if (!this.carouselPageList[prevPage]) {
        const mp = new Mprogress({
          template: 4,
          start: true,
          parent: '#js-coursework-entries-loader'
        });

        response = this.listCourseworkEntries(
          this.selectedCourseId(),
          this.selectedCourseworkId(),
          {
            page: prevPage,
            coursework_entry_id: this.courseworkEntry().id()
          }
        ).done(resp => {
          ko.mapping.fromJS(resp.coursework_entries)().reverse().forEach(
            entry => this.courseworkEntries.unshift(entry)
          );

          mp.end();
        });

        this.carouselPageList[prevPage] = true;
      }
    } else if (item.last_in_page()) {
      //Load next page
      const nextPage = (curPage + 1);

      if (!this.carouselPageList[nextPage]) {
        const mp = new Mprogress({
          template: 4,
          start: true,
          parent: '#js-coursework-entries-loader'
        });

        response = this.listCourseworkEntries(
          this.selectedCourseId(),
          this.selectedCourseworkId(),
          {
            page: nextPage,
            coursework_entry_id: this.courseworkEntry().id()
          }
        ).done(response => {
          ko.mapping.fromJS(response.coursework_entries).forEach(
            entry => this.courseworkEntries.push(entry)
          );

          mp.end();
        });

        this.carouselPageList[nextPage] = true;
      }
    }

    return response;
  };

  this.loadCarouselEntries = () => {
    this.carouselPageList = {};

    //
    // Load the first page
    //
    const response = this.fetchCourseworkEntries();

    response.done(response => {
      const carouselId = '#js-courseworkEntriesHolder';

      //
      // If there is no scroll bar, trigger loading the adjescent page
      //
      if ($(carouselId)[0].scrollWidth <= $('#js-coursework-viewer').width()) {
        if (response.meta.next_page) {
          //
          //Load next page
          //
          const item = this.courseworkEntries()[this.courseworkEntries().length - 1];
          this.loadAdjescentCarouselEntries(item);
        } else if (response.meta.current_page > 1) {
          //
          //Load previous page
          //
          const item = this.courseworkEntries()[0];
          this.loadAdjescentCarouselEntries(item);
        }
      }

      $(carouselId).scroll(() => {
        const maxWidth = $(carouselId)[0].scrollWidth - $(carouselId)[0].clientWidth;

        if ($(carouselId).scrollLeft() == 0) {
          const item = this.courseworkEntries()[0];
          this.loadAdjescentCarouselEntries(item);
        } else if ($(carouselId).scrollLeft() == maxWidth) {
          const item = this.courseworkEntries()[this.courseworkEntries().length - 1];
          this.loadAdjescentCarouselEntries(item);
        }
      });
    });

    return response;
  };

  this.goToCarouselEntry = id => {
    const carouselId = '#js-courseworkEntriesHolder';
    const left = $(`#entry_thumb_${id}`).offset().left;
    const width = $(carouselId).width();
    const diff = left - width / 2;

    const scrollLeft = $(carouselId).scrollLeft() + diff;

    $(carouselId).animate({ scrollLeft }, 1000);
  };

  this.makeRequest = _.memoize((url, loadingIndicator) => {
    return new Kadenze.AjaxRequest({
      type: 'GET',
      url: url,
      loadingIndicator: loadingIndicator
    });
  });

  this.deleteRequestCache = cacheKey => {
    delete this.makeRequest.cache[cacheKey];
  };

  this.getCourseworkEntry = id => {
    return this.makeRequest(
      Kadenze.Routes.course_gallery_coursework_coursework_entry_path(
        this.selectedCourseId(),
        this.selectedCourseworkId(),
        id,
        { sort: this.courseworkEntriesSort() }
      ),
      {
        container: this.loadingContainerId(),
        positionTop: 'absolute'
      }
    );
  };

  this.findCourseworkEntryByCoursework = courseworkId => {
    if (!isNaN(parseInt(courseworkId)))
      return this.makeRequest(
        Kadenze.Routes.find_course_gallery_coursework_coursework_entries_path(
          this.courseworkEntry().course.id(),
          courseworkId,
          { sort: this.courseworkEntriesSort() }
        ),
        {
          container: this.loadingContainerId(),
          positionTop: 'absolute'
        }
      );
  };

  this.findCourseworkEntryByCourse = courseId => {
    if (!isNaN(parseInt(courseId))) {
      return this.makeRequest(
        Kadenze.Routes.find_course_gallery_coursework_coursework_entries_path(
          courseId,
          -1,
          { sort: this.courseworkEntriesSort() }
        ),
        {
          container: this.loadingContainerId(),
          positionTop: 'absolute'
        }
      );
    }
  };

  this.listCourseworkEntries = (courseId, courseworkId, params) => {
    const modifiedParams = Object.assign({}, params, {
      sort: this.courseworkEntriesSort(),
      browsing_scope: this.currentBrowsingScope()
    });

    return this.makeRequest(
      Kadenze.Routes.list_course_gallery_coursework_coursework_entries_path(
        courseId,
        courseworkId,
        modifiedParams
      )
    );
  };

  this.resetCourseworkEntries = () => {
    this.showUsers(false);
    this.totalCourseworkEntries(null);
    this.courseworkEntries([]);
    this.carouselPageList = {};
  };

  this.refreshURL = (params = {}) => {
    if (this.courseworkEntry()) {
      const modifiedParams = Object.assign({}, params, {
        browse: this.currentBrowsingScale(),
        browsing_scope: this.currentBrowsingScope()
      });

      const url = Kadenze.Routes.course_gallery_detail_path(
        this.courseworkEntry().course.slug(),
        this.courseworkEntry().coursework.slug(),
        this.courseworkEntry().student.slug(),
        modifiedParams
      );

      if (this.referredByIndex) {
        history.pushState($.pjax.state, null, url);
      } else {
        history.replaceState($.pjax.state, null, url);
      }
    }
  };

  this.gradientClass = item => {
    if (_.isEmpty(item.thumbnail_image())) {
      const gradient_index = item.id() % Kadenze.GRADIENTS.length;
      return Kadenze.GRADIENTS[gradient_index];
    } else {
      return null
    }
  };

  this.totalCommentCount = ko.computed(() => {
    if (this.courseworkEntry()) {
      return this.courseworkEntry().coursework_field_entries().reduce(
        (memo, field_entry) => memo +  parseFloat(field_entry.comment_count()),
        0
      )
    } else {
      return 0
    }
  });

  this.commentCount = ko.computed({
    read: () => {
      const fieldEntry = this.currentFieldEntryObj();

      if (fieldEntry) {
        return  fieldEntry.comment_count();
      } else {
        return 0;
      }
    },

    write: value => {
      const fieldEntry = this.currentFieldEntryObj();

      if (fieldEntry) {
        fieldEntry.comment_count(value);
      }
    }
  });

  this.addNewComment = () => {
    this.loginOrRegister().done(() => {
      this.showCommentField(true);
      document.getElementsByClassName("ql-editor")[1].innerHTML = '';

      if (this.mobileView()) {
        this.replyingTo(null);
        this.toggleCommentModal();

        //
        // focus on comment field.
        // Wish I could have come up with a ko binding instead of jquery
        //
        setTimeout(() => {
          //
          // TODO: Quill ?
          //
          // $('#newCommentEditor').redactor('core.getEditor').focus();
        }, 500 );
      }
    });
  };

  this.initCommentPaginationEvents = () => {
    Kadenze.PaginationBinding.applyBindingsWithTextInput(
      this.commentPageChanged.bind(this)
    );
  };

  this.commentPageChanged = url => this.fetchComments(url);

  this.fetchComments = url => {
    url = url ||
      Kadenze.Routes.course_gallery_coursework_coursework_field_entry_comments_path(
        this.courseworkEntry().course.id(),
        this.courseworkEntry().coursework.id(),
        this.currentFieldEntryId(),
        { sort: this.commentSort() }
      );

    const request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: url,
      loadingIndicator: {
        container: '.coursework-viewer__comment-panel_content',
        positionTop: 'absolute'
      }
    });

    request.done(this.mapComments);

    request.always(() => this.initCommentPaginationEvents());
  };

  this.mapComments = (response) => {
    let mapping = {
      create: (options) => {
        return this.addCommentAttrs(options.data.comments);
      }
    };

    this.commentPaginator(response.meta.paginator);
    this.commentCount(response.meta.total_count);
    this.comments(ko.mapping.fromJS(response, mapping));
  };

  this.addCommentAttrs = (comments) => {
    return _.map(comments, (com) => {
      com.showReplies = false;
      com.isReplying = false;
      com.isEditing = false;
      com.replyComment = '';
      com._destroy = false;

      if(!_.isEmpty(com.thread_comments)) {
        this.addCommentAttrs(com.thread_comments);
      }

      if(_.isUndefined(com.thread_comments)) {
        com.thread_comments = [];
      }

      return ko.mapping.fromJS(com);
    });
  };

  this.createComment = (com, event) => {
    let params = {};
    const button = Ladda.create(event.target);

    if (button)
      button.start();

    com = com || this.replyingTo();

    if (com && com.replyComment && !s.isBlank(com.replyComment())) {
      params = {
        content: com.replyComment(),
        commentable_id: com.id(),
        commentable_type: 'ThreadComment'
      };
    } else {
      params = {
        content: this.newComment(),
        commentable_id: this.currentFieldEntryId(),
        commentable_type: 'CourseworkFieldEntry'
      };
    }
    const request = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.course_gallery_coursework_coursework_field_entry_comments_path(
        this.courseworkEntry().course.id(),
        this.courseworkEntry().coursework.id(),
        this.currentFieldEntryId(),
      ),
      data: { _method: 'POST', thread_comment: params  }
    });
    request.done(response => {
      this.appendNewComment(response, com);

      if (this.mobileView()) {
        this.toggleCommentModal();
      } else {
        this.showCommentField(false);
      }
    });
    request.fail((xhr, status, msg) => {
      if (xhr.responseJSON) {
        msg = xhr.responseJSON.message;
      }
      new Kadenze.Notice.error({message: msg});
    });

    request.always((xhr, textStatus) => {
      if (button)
        button.stop();
    });
  };

  this.appendNewComment = (response, existingComment) => {
    let parsed = JSON.parse(response.thread_comment);
    let newComment = _.first(this.addCommentAttrs([parsed]));

    if(newComment.commentable_type() == 'ThreadComment') {
      existingComment.thread_comments.unshift(newComment);
      existingComment.replyComment('');
      existingComment.isReplying(false);
      this.replyingTo(null);
    } else {
      this.comments.unshift(newComment);
      this.newComment('');
      this.commentCount(this.commentCount() + 1);
    }

    new Kadenze.Notice.success({ message: 'Posted Comment' });
  };

  this.saveComment = (comment, deleted) => {
    if (comment.allowed_to_edit() || comment.viewing_by_instructor()) {
      const commentParams = {
        id: comment.id(),
        user_id: comment.user.id(),
        content: comment.content(),
        commentable_id: comment.parent_id(),
        commentable_type: comment.parent_type(),
        deleted: deleted
      };

      const request = new Kadenze.AjaxRequest({
        type: 'PUT',
        url: Kadenze.Routes.course_gallery_coursework_coursework_field_entry_comment_path(
          this.courseworkEntry().course.id(),
          this.courseworkEntry().coursework.id(),
          this.currentFieldEntryId(),
          comment.id()
        ),
        data: { _method: 'PUT', thread_comment: commentParams  }
      });

      request.done(response => {
        if(deleted) {
          comment._destroy(true);

          if (commentParams['commentable_type'] != 'ThreadComment')
            this.commentCount(this.commentCount() - 1);

          new Kadenze.Notice.success({ message: 'Deleted comment' });
        } else {
          comment.isEditing(false);

          if (this.mobileView())
            this.toggleCommentModal();

          new Kadenze.Notice.success({ message: 'Updated comment' });
        }
      });
      request.fail((response, status, msg) => {
        if (response.responseJSON) {
          msg = response.responseJSON.message;
        }
        new Kadenze.Notice.error({message: msg});
      });
    }
  };

  this.editComment = comment => {
    comment.isEditing(true);
    if (this.mobileView()) {
      this.activeComment(comment);
      this.toggleCommentModal();
    }
  };

  this.deleteComment = comment => {
    this.saveComment(comment, true);
  };

  this.likeComment = comment => {
    this.loginOrRegister().done(() => {
      if (!comment.favorited()) {
        comment.favorite_count(comment.favorite_count() + 1);
        comment.favorited(true);
      } else {
        comment.favorite_count(comment.favorite_count() - 1);
        comment.favorited(false);
      }

      const data = {
        voteable_type: 'ThreadComment',
        voteable_id: comment.id()
      };

      new Kadenze.AjaxRequest({
        url: Kadenze.Routes.favorite_path(), //TODO: Move this under gallery namespace
        data: { thread_vote: data }
      });
    });
  };

  this.viewReplies = com => {
    com.showReplies(!com.showReplies());
    com.isReplying(false);
  };

  this.replyToComment = com => {
    this.loginOrRegister().done(() => {
      com.isReplying(!com.isReplying());
      com.showReplies(true);

      if (this.mobileView()) {
        this.showCommentField(true);
        this.replyingTo(com);
        this.activeComment(com);
        this.toggleCommentModal();
      }
    });
  };

  this.sortComments = type => {
    this.commentSort(type);
    this.fetchComments();
  };

  this.toggleCommentModal = () => {
    $('#coursework_entry_comment_modal').modal('toggle');
  };

  this.downloadSubmission = () => {
    const url = this.courseworkEntry().create_archive_path();

    const request = new Kadenze.AjaxRequest({
      type: 'POST',
      url,
      data: null,
      timeout: 60000
    });

    request.done((response, status, xhr) => {
      new Kadenze.Notice.success({message: response.message});
    });

    request.fail((xhr, status, msg) => {
      new Kadenze.Notice.error({
        message: 'There was an error creating an archive for download. Please contact an administrator.'
      });
    });
  };

  this.showShareModal = () => {
    Kadenze.Analytics.track(
      'coursework_entry',
      'share',
      { entry: ko.mapping.toJS(this.courseworkEntry().tracking_data) }
    );

    const params = {
      modal_title: 'Share this submission',
      shareableObj: {
        title: 'Kadenze',
        description: 'Kadenze brings together educators, artists, and engineers from leading universities to provide world-class education in the fields of art and creative technology.',
        share_url: this.courseworkEntry().share_url(),
        coursework_entry_share_path: Kadenze.Routes.course_gallery_coursework_coursework_entry_share_path(
          this.courseworkEntry().course.id(),
          this.courseworkEntry().coursework.id(),
          this.courseworkEntry().id()
        )
      },
      emailShareCb: GalleryServices.shareSubmission
    };

    new Kadenze.ShareModal(params).show();
  };

  this.toggleSubmissionLike = () => {
    const favorited = this.courseworkEntry().favorited();

    this.courseworkEntry().favorited(!favorited);

    if (this.courseworkEntry().favorited()) {
      this.courseworkEntry().favorite_count(this.courseworkEntry().favorite_count() + 1);
    } else {
      this.courseworkEntry().favorite_count(this.courseworkEntry().favorite_count() - 1);
    }
  };

  this.likeSubmission = () => {
    this.loginOrRegister().done(() => {
      this.toggleSubmissionLike();

      this.deleteRequestCache(
        Kadenze.Routes.course_gallery_coursework_coursework_entry_path(
          this.courseworkEntry().course.id(),
          this.courseworkEntry().coursework.id(),
          this.courseworkEntry().id(),
          { sort: this.courseworkEntriesSort() }
        )
      );

      const request = new Kadenze.AjaxRequest({
        url: Kadenze.Routes.course_gallery_coursework_coursework_entry_favorite_path(
          this.courseworkEntry().course.id(),
          this.courseworkEntry().coursework.id(),
          this.courseworkEntry().id()
        )
      });

      request.fail(() => this.toggleSubmissionLike())
    });
  };

  this.zoomIn = () => {
    $('#coursework_entry_image_modal').modal('show');

    setTimeout(
      () => $('.modal#coursework_entry_image_modal').find('.coursework-viewer__slide_fab').find('a').first().focus(),
      250
    );
  };

  this.zoomOut = () => {
    $('#coursework_entry_image_modal').modal('hide');

    setTimeout(
      () => $('.coursework-viewer__main').find('.coursework-viewer__slide_fab').find('a').first().focus(),
      250
    );
  };

  this.tooltipShown = tooltip => {
    $(window).trigger('resize');

    if (!$(tooltip.template).is(':visible')) {
      setTimeout(() => this.tooltipShown(tooltip), 100);
    } else {
      $('#gallery_tour_modal').modal('show');

      this.tooltips.push(tooltip);

      setTimeout(() => $(tooltip.template).focus(), 300);

      if (tooltip.config.interactive.order === 3) {
        this.showUsers(true);
      } else if (tooltip.config.interactive.end) {
        $('#js-overflowHeaderMenuToggle').dropdown('toggle');

        $('#js-overflowHeaderMenuContainer')
          .off('hide.bs.dropdown')
          .on('hide.bs.dropdown', () => tooltip.interactiveHide())
      }
    }
  };

  this.tooltipHidden = tooltip => {
    if (tooltip.config.interactive.order === 3) {
      this.showUsers(false);
    } else if (tooltip.config.interactive.end) {
      $('#gallery_tour_modal').modal('hide');
    }
  };

  this.tooltipSkipped = tooltip => $('#gallery_tour_modal').modal('hide')

  this.hideTooltips = () => this.tooltips.forEach(tooltip => tooltip.destroy())

  this.restartTour = () => {
    this.tooltips.forEach(tooltip => tooltip.interactiveHide())
    Kadenze.Tooltip.prototype.resetCurrentPos('CourseGallery');
  };

  this.tourInProgress = () => $('#gallery_tour_modal').hasClass('in')

  this.interactiveTooltipParams = (order, end) => {
    return {
      context: 'CourseGallery',
      order,
      end: (end || false),
      events: {
        onShow: this.tooltipShown,
        onHide: this.tooltipHidden,
        onSkip: this.tooltipSkipped
      }
    };
  };

  this.userInfoTooltipParams = user => {
    return {
      template: 'templates/tooltip-userinfo',
      templateParams: {
        full_name: user.full_name(),
        username: user.slug(),
        avatar: user.avatar(),
        profile_path: user.profile_path(),
        message_path: user.message_path()
      },
      position: 'top',
      showDelay: .7
    };
  };

  (() => {
    if (typeof data.onInitialize === 'function')
      data.onInitialize(this);

    this.bindCourseworkEntry(data.coursework_entry);

    this.courseList(ko.mapping.fromJS(data.course_list)());

    this.courseworkList(ko.mapping.fromJS(data.coursework_list)());

    this.currentBrowsingScope(data.browsing_scope || 'course');
    this.currentUserType(data.user_type || 'enrolled');

    if (this.publicView()) {
      //
      // disable pjax so public layout is loaded for pages in the public nav
      //
      $(document).pjax(
        'a[href]:not([data-remote]):not([data-behavior]):not([data-skip-pjax]):not([target="_blank"]):not([href^="javascript"])',
        '[data-pjax-container]',
        { timeout: 1 }
      );
    }

    this.interceptURLParams();

    this.courseworkEntryId(this.courseworkEntry().id());

    this.courseworkEntryId.subscribe(this.fetchCourseworkEntry);
    this.courseworkEntry.subscribe(() => this.refreshURL({}));

    if (this.currentBrowsingScope() === 'global') {
      this.selectedCourseId.subscribe(value => {
        if (!isNaN(parseInt(value))) {
          this.resetCourseworkEntries();
          this.fetchCourseworkEntry('find');
        }
      });
    } else {
      this.selectedCourseworkId.subscribe(value => {
        if (!isNaN(parseInt(value))) {
          this.resetCourseworkEntries();
          this.fetchCourseworkEntry('find');
        }
      });
    }

    this.showUsers.subscribe(value => {
      if (value)
        this.loadCarouselEntries().done(() => {
          this.goToCarouselEntry(this.courseworkEntry().id());
        });
    });

    this.currentFieldEntryId.subscribe(id => {
      if (this.viewMode() == 'comment')
        this.fetchComments();
    });

    if (typeof data.onReady === 'function')
      data.onReady(this);

    if (data.referrer)
      this.referrer(data.referrer);

    this.referredByIndex = window.location.pathname
      .split('/')
      .filter(Boolean)
      .length <= 4;

    //
    //If this is opened in a modal, close it when the back button is clicked
    //
    $(window).on('popstate', () => {
      if (
        this.referredByIndex &&
          this.referrer() &&
            typeof this.referrer().action === 'function'
      )
        this.referrer().action(this);
    });

    this.initFullViewTimeout();
  })();
}
